import React from 'react';
import { Typography, TypographyType } from '../typography';
import clsx from 'clsx';

interface Props {
	blackText: string;
	colorText: string;
	className?: string;
	textSize?: TypographyType;
}

export const SplitColorTitle: React.FC<Props> = ({
	blackText,
	colorText,
	textSize = 'custom-h2',
	className,
}) => {
	return (
		<Typography type={textSize} className={clsx(className)}>
			{`${blackText} `}
			<span className="text-purple-150">{colorText}</span>
		</Typography>
	);
};
